import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Loading from '../Common/Loading';
import DescriptionEdit from '../Common/DescriptionEdit';
import { handleOnKeyDown } from '../../lib/utils/commonutils';
import ReactMarkdown from 'react-markdown';
import { setTitle } from '../../lib/utils/windowutils';
import Sites from '../../lib/models/sites/sites';
import { ltToast } from '../Common/LTToast';
import { Link } from 'react-router-dom';
import Customers from '../../lib/models/Customers';
import Octicon, { Link as IconLink } from '@githubprimer/octicons-react';

class SiteView extends PureComponent {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  };

  state = {
    site: false,
    customer_id: false,
    customers: { rows: [] },
    editField: '',
    editValue: '',
    editing: false
  };

  refInput = React.createRef();

  render() {
    const { site, customers, editing, editField, editValue } = this.state;
    if (!site) {
      return <Loading />;
    }

    return (
      <div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin/">Admin</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/admin/sites">Sites</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Edit
            </li>
          </ol>
        </nav>
        <h5 className="mb-3">Edit Site</h5>
        <div className="row">
          <div className="mb-3 col-12 col-md-6 col-lg-4">
            <div className="card border-info">
              <div className="card-header bg-info text-white">
                <strong>Detail</strong>
              </div>
              <div className="card-body">
                <dl className="row">
                  <dt className="col-12 col-md-4 col-lg-3">Code</dt>
                  <dd
                    className="col-12 col-md-8 col-lg-9"
                    onClick={e => this.setState({ editField: 'code', editValue: site.code, editing: true })}
                  >
                    {(!editing || editField !== 'code') && <DescriptionEdit>{site.code}</DescriptionEdit>}
                    {editing && editField === 'code' && (
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={editValue}
                        ref={this.refInput}
                        onBlur={this.saveEdit}
                        onKeyDown={e => handleOnKeyDown(e, this.saveEdit)}
                        onChange={e => this.setState({ editValue: e.target.value })}
                      />
                    )}
                  </dd>
                  <dt className="col-12 col-md-4 col-lg-3">Description</dt>
                  <dd
                    className="col-12 col-md-8 col-lg-9"
                    onClick={e =>
                      this.setState({ editField: 'description', editValue: site.description, editing: true })
                    }
                  >
                    {(!editing || editField !== 'description') && (
                      <DescriptionEdit>
                        <ReactMarkdown source={site.description} />
                      </DescriptionEdit>
                    )}
                    {editing && editField === 'description' && (
                      <div>
                        <span>
                          Use Markdown:{' '}
                          <a
                            href="https://en.support.wordpress.com/markdown-quick-reference/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Help
                          </a>
                        </span>
                        <textarea
                          className="form-control form-control-sm"
                          value={editValue}
                          autoCorrect="off"
                          rows={5}
                          ref={this.refInput}
                          onBlur={this.saveEdit}
                          onChange={e => this.setState({ editValue: e.target.value })}
                        />
                      </div>
                    )}
                  </dd>
                </dl>
                <dl className="row mb-0">
                  <dt className="col-12 col-md-4 col-lg-3">Customer</dt>
                  <dd
                    className="col-12 col-md-8 col-lg-9"
                    onClick={e =>
                      this.setState({ editField: 'customer_id', editValue: site.customer_id, editing: true })
                    }
                  >
                    {(!editing || editField !== 'customer_id') && (
                      <DescriptionEdit>
                        [{site.customer_code}]&nbsp;{site.customer_description}
                      </DescriptionEdit>
                    )}
                    {editing && editField === 'customer_id' && (
                      <select
                        className="form-control"
                        onChange={e => this.setState({ editValue: e.target.value })}
                        onBlur={this.saveEdit}
                        value={editValue}
                      >
                        {customers.rows.map((customer, i) => {
                          return (
                            <option key={i} value={customer.id}>
                              [{customer.code}]&nbsp;{customer.description}
                            </option>
                          );
                        })}
                      </select>
                    )}
                    <div className="mt-3">
                      <Link className="btn btn-info" to={`/admin/customers/${site.customer_id}`} title="Edit Customer">
                        <Octicon icon={IconLink} size="small" />
                      </Link>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="mb-3 col-12 col-md-6 col-lg-4">
            <div className="card border-danger">
              <div className="card-header bg-danger text-white">
                <strong>DANGER ZONE</strong>
              </div>
              <div className="card-body">
                <button className="btn btn-danger" onClick={this.handleDelete}>
                  DELETE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.loadSite();
    Customers.find({ limit: 100 }).then(customers => {
      this.setState({ customers });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.site && this.state.site.id && !prevState.site.id) {
      setTitle(this.state.site.code);
    }
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.loadSite();
    }
    if (!prevState.editing && this.state.editing && this.refInput.current) {
      this.refInput.current.focus();
    }
  }

  handleChange = e => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value
    });
    this.setState({ editField: e.target.name, editValue: e.target.value });
  };

  handleDelete = e => {
    e.preventDefault();
    const ok = window.confirm('Are you sure?');
    if (ok) {
      const { site } = this.state;
      Sites.delete(site.id)
        .then(() => {
          this.props.history.push('/admin/sites');
        })
        .catch(e => {
          ltToast('Unable to delete entity: ' + e.message, 5000, true);
        });
    }
  };

  saveEdit = () => {
    const { editField, editValue, site } = this.state;
    this.setState({ editField: '', editValue: '', editing: false });
    this.refInput = React.createRef();
    if (site[editField] !== editValue) {
      Sites.update(site.id, editField, editValue)
        .then(site => {
          this.setState({ site });
        })
        .catch(e => {
          ltToast('Unable to save: ' + e.message, 5000, true);
        });
    }
  };

  loadSite = () => {
    const { match } = this.props;
    const { params } = match;
    Sites.get(params.id)
      .then(site => {
        this.setState({
          site
        });
      })
      .catch(e => console.error('err', e.message));
  };
}

export default SiteView;
